import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ForgotPasswordConfirmationPage } from '../forgot-pasword-confirmation/forgot-pasword-confirmation';

@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html'
})
export class ForgotPasswordPage {

  constructor(public navCtrl: NavController) {

  }

    /**
       * goToForgotpassword
      */
    public goToForgotPasswordConfirmation() {
        this.navCtrl.push(ForgotPasswordConfirmationPage, {});
    }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-pasword/forgot-password.ts